export default __webpack_public_path__ + "static/media/processwire-icon.d2d9a6c9.svg";